import OverviewTabContent from "../../../../../../shared/components/overview-panel/OverviewTabContent";
import OverviewTabs from "../../../../../../shared/components/overview-panel/OverviewTabs";
import ClientCampaignsTable from "./campaign/ClientCampaignsTable";
import ClientsCategoryTable from "./category/ClientsCategoryTable";
import ClientMarketsTable from "./market/ClientMarketsTable";
import PlatformsClientMappingTable from "./platformMapping/PlatformsClientMappingTable";
import ClientProductsTable from "./product/ClientProductsTable";

const ClientDetailTabMenu = ({
  market,
  campaign,
  category,
  product,
  platformMapping,
}) => {
  const tabs = [
    {
      trigger: {
        value: "markets",
        label: "clients.detail.tabs.trigger.markets",
      },
      content: (
        <OverviewTabContent
          value="markets"
          title="clients.detail.tabs.markets.title"
          description="clients.detail.tabs.markets.description"
          options={market?.options}
        >
          <ClientMarketsTable
            data={market?.data}
            onMarketEdition={market?.edit}
            onMarketDeletion={market?.delete}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "campaigns",
        label: "clients.detail.tabs.trigger.campaigns",
      },
      content: (
        <OverviewTabContent
          value="campaigns"
          title="clients.detail.tabs.campaigns.title"
          description="clients.detail.tabs.campaigns.description"
          options={campaign?.options}
        >
          <ClientCampaignsTable
            data={campaign?.data}
            onCampaignEdition={campaign?.edit}
            onCampaignDeletion={campaign?.delete}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "categories",
        label: "clients.detail.tabs.trigger.categories",
      },
      content: (
        <OverviewTabContent
          value="categories"
          title="clients.detail.tabs.categories.title"
          description="clients.detail.tabs.categories.description"
          options={category?.options}
        >
          <ClientsCategoryTable
            data={category?.data}
            onCategoryEdition={category?.edit}
            onCategoryDeletion={category?.delete}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "products",
        label: "clients.detail.tabs.trigger.products",
      },
      content: (
        <OverviewTabContent
          value="products"
          title="clients.detail.tabs.products.title"
          description="clients.detail.tabs.products.description"
          options={product?.options}
        >
          <ClientProductsTable
            data={product?.data}
            onProductEdition={product?.edit}
            onProductDeletion={product?.delete}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "platformMappings",
        label: "clients.detail.tabs.trigger.platformMappings",
      },
      content: (
        <OverviewTabContent
          value="platformMappings"
          title="clients.detail.tabs.platformMappings.title"
          description="clients.detail.tabs.platformMappings.description"
          options={platformMapping?.options}
        >
          <PlatformsClientMappingTable
            data={platformMapping?.data}
            onPlatformMappingEdition={platformMapping?.edit}
            onPlatformMappingDeletion={platformMapping?.delete}
          />
        </OverviewTabContent>
      ),
    },
  ];
  return (
    <div className="grid flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0 md:gap-8">
      <OverviewTabs tabs={tabs} defaultTabValue={"markets"} />
    </div>
  );
};

export default ClientDetailTabMenu;
